import { Checkbox } from "@similarweb/ui-components";
import type ColumnSuggestion from "../../models/ColumnSuggestion";
import { StyledList } from "./styles";

type Props = {
    selectedColumnsNames: readonly string[];
    columnSuggestions: readonly ColumnSuggestion[];
    onColumnSelect(columnName: string): void;
};

const ColumnSuggestionsList = ({ selectedColumnsNames, columnSuggestions, onColumnSelect }: Props) => {
    return (
        <StyledList>
            {columnSuggestions.map(({ field, displayName }) => {
                const isSelected = selectedColumnsNames.includes(field);

                return (
                    <li key={field}>
                        <Checkbox
                            label={displayName}
                            selected={isSelected}
                            onClick={() => onColumnSelect(field)}
                        />
                    </li>
                );
            })}
        </StyledList>
    );
};

export default ColumnSuggestionsList;
